import { getBaseURL } from 'utility/httpClient.util'
import { getAttachmentId } from './resourceUpload'

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value)

const normalizeBindKey = (key = '') =>
  `${key || ''}`.trim().replace(/^\{\{/, '').replace(/\}\}$/, '').trim()

const getValueByPath = (source, path) => {
  if (!source || !path) return undefined

  return path.split('.').reduce((result, key) => {
    if (result === null || typeof result === 'undefined') return undefined

    return result[key]
  }, source)
}

export const getReportBindValue = (source, bindKey) => {
  const key = normalizeBindKey(bindKey)
  if (!key || !source) return undefined

  if (Object.prototype.hasOwnProperty.call(source, key)) {
    return source[key]
  }

  return getValueByPath(source, key)
}

export const createReportDataSourceMap = (dataSourceList = []) =>
  (dataSourceList || []).reduce(
    (result, element) => {
      const fieldValue = element?.fieldVariable?.value
      const values = Array.isArray(fieldValue)
        ? fieldValue
        : isPlainObject(fieldValue)
        ? [fieldValue]
        : []

      values.forEach((item) => {
        if (isPlainObject(item)) {
          Object.assign(result, item)
        }
      })

      if (element?.dataSourceId) {
        result._table[element.dataSourceId] = fieldValue
        result._columns[element.dataSourceId] = element?.fieldVariable?.columns
      }
      if (element?.name) {
        result._dsName[element.name] = fieldValue
      }

      return result
    },
    { _table: {}, _dsName: {}, _columns: {} },
  )

const normalizeImagePath = (value) => {
  const text = `${value || ''}`.trim()
  if (!text) return ''

  if (/^(https?:)?\/\//i.test(text)) return text
  if (/^data:image\//i.test(text)) return text
  if (/^blob:/i.test(text)) return text
  if (text.startsWith('/')) return text
  if (/^media\/attachment\//i.test(text)) return `${getBaseURL()}/${text}`

  return ''
}

export const resolveReportImageSource = (value) => {
  if (Array.isArray(value)) {
    return resolveReportImageSource(value[0])
  }

  if (isPlainObject(value)) {
    const attachmentId = getAttachmentId(value)
    if (attachmentId) {
      return `${getBaseURL()}/media/attachment/originalFile/${attachmentId}`
    }

    const sourceKeys = [
      'src',
      'url',
      'imageUrl',
      'imageURL',
      'fullPath',
      'path',
      'preview',
      'base64',
      'data',
      'value',
    ]

    for (const key of sourceKeys) {
      const source = resolveReportImageSource(value[key])
      if (source) return source
    }

    return ''
  }

  if (typeof value === 'string' || typeof value === 'number') {
    return normalizeImagePath(value)
  }

  return ''
}

export const getReportImageSource = (item = {}) => {
  const boundSource = item?.name ? resolveReportImageSource(item?.value) : ''
  if (boundSource) return boundSource

  if (item?.data?.preview) return item.data.preview

  const staticImageSource = resolveReportImageSource(item?.image)
  if (staticImageSource) return staticImageSource

  return resolveReportImageSource(item?.value)
}
